import styled from "styled-components";

export const KeyStatsContainer = styled.div`
  .key-statistics-container {
    background: #171d38;
    box-shadow: 0px 6px 24px rgba(1, 87, 255, 0.25);
    border-radius: 5px;
    width: 100%;
    padding: 1rem;
    padding-bottom: 0px;
    min-height: 200px;

    .no-stats-data {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #3c587c;
      font-size: 14px;
      height: 60%;
    }

    h3 {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      text-transform: capitalize;
      color: ${({ theme }) => theme.global.extraInfo.font.color};
    }

    ul {
      columns: 4;
      -webkit-columns: 4;
      -moz-columns: 4;
      padding: 0;
      margin: 0;
      padding-bottom: 0.7em;
      // @include respond-max("md-tab") {
      //   columns: 1;
      //   -webkit-columns: 1;
      //   -moz-columns: 1;
      // }
      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6.5px;

        span.key {
          font-style: normal;
          font-weight: 400;
          font-size: 9.5px;
          text-transform: capitalize;
          color: ${({ theme }) => theme.global.color.tertiary};
          width: 75%;
        }
        span.stats {
          font-style: normal;
          font-weight: 400;
          font-size: 9.5px;
          text-align: right;
          text-transform: capitalize;
          color: ${({ theme }) => theme.global.extraInfo.font.color};
          // margin-bottom: 6.5px;
        }
      }
    }
  }
`;

export const CardKeyStatsContainer = styled.div`
  min-height: 180px;

  .key-stats-wrapper {
    height: 180px;
    overflow: auto;

    ul {
      columns: 2;
      -webkit-columns: 2;
      -moz-columns: 2;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 21px;

        .key {
          font-weight: 500;
          font-size: ${({ theme }) => theme.constants.FONT_SIZE_14};
          text-transform: capitalize;
          color: ${({ theme }) => theme.global.extraInfo.font.color};
          display: flex;
          flex-direction: column;
        }

        .stats {
          font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_400};
          font-size: ${({ theme }) => theme.constants.FONT_SIZE_12};
          text-transform: capitalize;
          color: ${({ theme }) => theme.label.color.primary};
        }
      }
    }
  }

  .no-data {
    text-align: center;
  }
`;
